<nz-input-group
  nzSearch
  [nzAddOnAfter]="suffixButton"
  [nzSuffix]="inputClearTpl"
  [nzPrefix]="prefixIcon"
>
  <input
    #search
    nz-input
    [value]="searchTerm()"
    [placeholder]="'global.searchTerm' | translate"
    (keyup.enter)="searchUpdate.emit(search.value)"
    (keyup.backspace)="searchUpdate.emit(search.value)"
    (keyup.delete)="searchUpdate.emit(search.value)"
  />
</nz-input-group>

<ng-template #suffixButton>
  <button
    nz-button
    type="button"
    nzType="primary"
    nzSearch
    (click)="searchUpdate.emit(search.value)"
  >
    {{ 'global.search' | translate }}
  </button>
</ng-template>

<ng-template #inputClearTpl>
  @if (search.value) {
    <span
      nz-icon
      class="ant-input-clear-icon"
      nzTheme="fill"
      nzType="close-circle"
      aria-hidden="true"
      (click)="search.value = null; searchUpdate.emit(null)"
    ></span>
  }
</ng-template>

<ng-template #prefixIcon><span nz-icon nzType="search"></span></ng-template>
